import axios from "axios";
import {createUrlParams} from "../utils/urlParams";

export const getTimeseries = async (stationId, attributes) => {
    const urlParams = createUrlParams(attributes)
    const url = `/api/v1/timeseries/stations/${stationId}?${urlParams.toString()}`;

    const res = await axios.get(url);
    return res.data;
}

export const getModels1AvalancheCount = async (microZoneId) => {
    const url = `/api/v1/timeseries/micro_zones/${microZoneId}/models1_avalanche_count`;

    const res = await axios.get(url);
    return res.data;
}

export const getIncidents = async (filters) => {
    const urlParams = createUrlParams(filters)
    const url = `/api/v1/timeseries/incidents?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}